import { useTheme } from "@material-ui/core/styles";
import Logo from "./Logo";
import { CircularProgress } from "@material-ui/core";

const Loader = () => {
  const theme = useTheme();
  {
    /* <Logo
      size={200}
      sx={{
        "@keyframes pulse": {
          "0%": {
            opacity: 1,
          },
          "50%": {
            opacity: 0.4,
          },
          "100%": {
            opacity: 1,
          },
        },
        animation: "pulse 1.5s ease-in-out 0.5s infinite",
        color: theme.palette.mode === "light" ? "grey.300" : "grey.600",
        textAlign: "center",
        px: 3,
        py: 8,
      }}
    /> */
  }
  return <CircularProgress size={40} />;
};

export default Loader;
